import * as React from "react";
import { getLocalizedText } from "../util";
import { useLang } from "../lang";

type GrantsProps = {
  title_en: string;
  title_ja: string;
  items: Array<{
    term?: import("../../types/data").LocalizedOrString;
    name: import("../../types/data").LocalizedOrString;
    url?: import("../../types/data").LocalizedOrString;
    description?: import("../../types/data").LocalizedOrString;
  }>;
};

const Grants: React.FC<GrantsProps> = ({ title_en, title_ja, items }) => {
  const { langEn } = useLang();
  return (
    <div className="col-md-12">
      <p className="sub-title">{langEn ? title_en : title_ja}</p>
      <ul>
        {items.map((item, i) => (
          <li key={i}>
            <p className="mb-1">
              {getLocalizedText(item.term, langEn)}
              <span> : </span>
              {getLocalizedText(item.name, langEn)}
              {item.url ? (
                <a href={getLocalizedText(item.url, langEn)} className="ml-2 icon-link"></a>
              ) : (
                ""
              )}
              <br />
              {getLocalizedText(item.description, langEn)}
            </p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Grants;
